import { render, staticRenderFns } from "./PendingPaymentCard.vue?vue&type=template&id=1900e6c2&"
import script from "./PendingPaymentCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PendingPaymentCard.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports